import './App.css';
import React, {useState} from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";

import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api, legacyPhpUrl } from "./api/client";
import {adaptV4Theme, createTheme, ThemeProvider} from '@mui/material/styles';
import moment from "moment";

import Button from '@mui/material/Button';
import {toast, ToastContainer} from "react-toastify";
import EditIcon from "@material-ui/icons/Edit";
import ReplayIcon from '@mui/icons-material/Replay';
import ModalBoxSevkiyat from "./ModalboxSevkiyat";
import ModalBoxSevkiyatNotu from "./ModalboxSevkiyatNotu";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import IconButton from "@mui/material/IconButton";
import ModalboxEkler from "./ModalboxEkler";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
import { parseListResponse, buildPageParams, withServerSideOptions, makeServerTableHandler } from "./utils/serverSideTable";
import { applyFilterFacets, fetchTeklifFilterOptions } from "./utils/filterFacets";
import { formatTeklifTipi, TEKLIF_TIP_FILTER_NAMES } from "./utils/teklifTipi";
class Tamamlananlar extends React.Component {
    constructor(props) {
        super(props);
        this.state={ filterOpts: {}, count: 0, page: 0, rowsPerPage: 50, search: '', filters: {}, replace: "", datas:[],open:false,id:""};
    }
    async getDatas(){
        const pageParams = buildPageParams({
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            search: this.state.search,
            filters: this.state.filters,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            extra: {},
        });


        const res = await api.get('/teklifler/durum/tamamlanan', { params: pageParams })
        const { items: data, count } = parseListResponse(res)

        const products = data.map(d => ({
            "id":d.id ,
            "teklif_no" :  d.teklif_no,
            "teklif_tarihi":d.teklif_tarihi ,
            "teslim_tarihi" : d.son_teslim_tarihi ,
            "musteri" :  d.musteri,
            "lokasyon": d.lokasyon,
            "uyf_no" :  d.uyf_no,
            "seri_no" :  d.seri_no,
            "makine" :  d.makine,
            "dosya_bir": d.dosya_bir,
            "irsaliye":d.irsaliye,
            "dosya_iki" : d.dosya_iki,
            "dosya_uc" : d.dosya_uc,
            "temsilci": d.temsilci,
            "sevk_notlari": d.sevk_notlari,
            "teklif_dili":d.teklif_dili,
            "dosya_var":d.dosya_var,
            "msn": d.musteri_siparis_no || "",
            "tip": formatTeklifTipi(d.teklif_tipi || (d.sozlesme ? 'sozlesme' : 'teklif')),
        }))
        //console.log(products);
        this.setState({ datas: products, count })

    }
    async onayaGeriAl(value) {

        await api.post('/teklifler/' + value + '/tamamlandan-geri-al', {})
            .then((response) => {
                // Success 🎉
                console.log(response);
                toast.success("Tamamlan teklifi geri alma işlemi başarılı");

                const { datas } = this.state;
                datas.shift();
                this.setState({ datas });
                this.setState({ open:false });
                window.location.reload();

            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }
    async sevkEt(value) {

        await api.post('/teklifler/' + value + '/sevk-et', {})
            .then((response) => {
                // Success 🎉
                console.log(response);
                toast.success("Sevk etme işlemi başarılı");

                const { datas } = this.state;
                datas.shift();
                this.setState({ datas });
                window.location.reload();
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }


    
    async loadFilterOptions() {
        try {
            const opts = await fetchTeklifFilterOptions('tamamlanan');
            this.setState({ filterOpts: { ...opts, tip: TEKLIF_TIP_FILTER_NAMES } });
        } catch (e) {
            console.warn('filter options', e);
        }
    }

    componentDidMount() {
        this.loadFilterOptions();
        this.getDatas(true);
    }
    sevkEdilmis = () => {
        window.location.reload();
    }
    handleClose() {
        this.setState({open:false})
    }
    sevkiyatNotu = (value, meta) => {

        const record = this.state.datas[meta.currentTableData[meta.rowIndex].index];

        if (value) {
            return (
                <ModalBoxSevkiyatNotu  key={meta.rowIndex}  id={record.id} sevkEdilmis={this.sevkEdilmis} sevk_notu={ record.sevk_notlari} />
            );
        }

        return null; // Or other fallback content
    };

    eklerBodyRender = (value, meta) => {

        const record = this.state.datas[meta.currentTableData[meta.rowIndex].index];

        if (value) {
            return (
                <ModalboxEkler key={meta.rowIndex} teklifNo={record.teklif_no}  dosyaVar={record.dosya_var} />
            );
        }

        return null; // Or other fallback content
    };
    render() {
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {

                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },


            },
        }));
        const columns = [
            {
                name: "id",
                label: "İşlemler",
                options: {
                    filter: false,
                    sort: false,
                    setCellProps: () => ({ style: { whiteSpace: 'nowrap', width: 1 } }),
                    customBodyRender: (value, tableMeta) => {
                        const record = data[tableMeta.currentTableData[tableMeta.rowIndex].index];
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
                                {value && (
                                    <Tooltip title="Geri Al"><span>
                                        <IconButton size="small" onClick={() => { this.setState({ id: value, open: true }); }} color={"secondary"} variant="outlined">
                                            <ReplayIcon />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                                {record.teklif_no && (
                                    <Tooltip title="İş emrine dönüştür"><span>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => this.props.navigate?.(
                                                `/talep-ekle?teklif_no=${encodeURIComponent(record.teklif_no)}`
                                            )}
                                            sx={{ textTransform: 'none', whiteSpace: 'nowrap', minWidth: 0, px: 1, py: 0.25, fontSize: 12 }}
                                        >
                                            İş emrine dönüştür
                                        </Button>
                                    </span></Tooltip>
                                )}
                                {this.sevkiyatNotu(record.sevk_notlari, tableMeta)}
                                <ModalBoxSevkiyat
                                    id={record.id} sevk_notu={record.sevk_notlari} teklifNo={record.teklif_no} sevkEdilmis={this.sevkEdilmis}
                                />
                            </div>
                        );
                    },
                },
            },
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = data[meta.currentTableData[meta.rowIndex].index];
                        if (value) {
                            return (
                                <MalzemeListesiOnizleme teklifNo={value} teklifDili={record.teklif_dili} teklifTarihi={record.teklif_tarihi} musteri={record.musteri}/>
                            );
                        }
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "msn",
                label: "MSN",
                options: { filter: false, sort: false },
            },
            {
                name: "tip",
                label: "Tip",
                options: { filter: true, sort: true },
            },
            {
                name: "teklif_tarihi",
                label: "Teklif Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );
                        }
                    },
                },
            },
            {
                name: "teslim_tarihi",
                label: "Teslim Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                },
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                value.substring(0, value.indexOf(' '))
                            );

                        }
                    }
                }
            },
            {
                name: "lokasyon",
                label: "Lokasyon",
                options: {
                    /*customBodyRenderLite: (dataIndex) => {
                        let val = data[dataIndex][3];
                        return val;
                    },*/
                    filter: false,
                }
            },
            {
                name: "makine",
                label:"Makine",
                options: {
                    filter: false,
                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "uyf_no",
                label:"UYF No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "seri_no",
                label:"Seri No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
            {
                name: "teklif_no",
                label:"Ek",
                options: {
                    filter:false,
                    customBodyRender: (value, meta, updateValue) => {

                        return (
                            this.eklerBodyRender(value,meta)
                        );

                    },
                    sort:false,
                }
            },
            {
                name: "temsilci",
                label:"Temsilci",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },
        ];
        const data =  this.state.datas;

        let datas=[];
        const options = {
            sortOrder: { name: "teklif_tarihi", direction: "asc" },
            filter: true,

            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: this.state.rowsPerPage,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '80%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },

            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },

            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Tamamlanan Teklifler Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },

        };

        return (
            <ThemeProvider theme={myTheme}>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover

                />
                <MUIDataTable title={"Tamamlanan Teklifler"} data={data} columns={enhanceColumns(applyFilterFacets(columns, this.state.filterOpts))} options={withTableOptions(withServerSideOptions(options, {
                    count: this.state.count,
                    page: this.state.page,
                    rowsPerPage: this.state.rowsPerPage,
                    sortBy: this.state.sortBy,
                    sortDir: this.state.sortDir,
                    onServerTableChange: makeServerTableHandler(this),
                }))} />
                <Dialog
                    open={this.state.open}
                    onClose={()=>{this.handleClose(true)}}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">Onaylananlara Geri Gönder</DialogTitle>
                    <DialogContent>
                        Teklif onaylananlara geri gönderilsin mi?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{this.handleClose(true)}} color="primary">
                            İptal
                        </Button>
                        <Button

                            onClick={ ()=>{ this.onayaGeriAl(this.state.id,true).then(r=>console.log(r)) }}
                            color="primary"
                        >
                            Gönder
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        );

    }


}

function TamamlananlarPage() {
    const navigate = useNavigate();
    return <Tamamlananlar navigate={navigate} />;
}

export default TamamlananlarPage;
